<template>
    <div class="content-center">
      <div class="banner">
        <div class="content">
            <div class="banner_title">千橙系列产品</div>
            <div class="banner_text">官方下载获取专区</div>
        </div>
      </div>
      <div class="download">
        <div class="content content_store">
            <div class="content_left  content_left1">
                <div class="left_title">千橙掌柜门店系统</div>
                <div class="left_text">聚焦门店经营管理</div>
            </div>
            <div class="content_right">
                <div class="right_box right_3">
                    <img src="@/assets/images/QcDownload/box1.png" alt="">
                    <p>千橙掌柜</p>
                    <div class="box_btn">
                        <div class="btn1" @click="addTimeStamps(QcShopkeeperUrl)">
                            <div class="btn_text" >安卓客户端</div>
                        </div>
                        <div class="btn2" @click="goApple('https://apps.apple.com/cn/app/%E6%B1%87%E4%BA%AB%E8%B4%AD%E5%95%86%E5%AE%B6%E7%89%88/id1585589549')">
                            <div class="btn_text" >苹果客户端</div>
                        </div>
                    </div>
                </div>
                <div class="right_box right_3">
                    <img src="@/assets/images/QcDownload/box2.png" alt="">
                    <p>千橙收银</p>
                    <div class="box_btn">
                        <div class="btn1" @click="addTimeStamps(QcCashierUrl)">
                            <div class="btn_text"  >安卓客户端</div>
                        </div>
                    </div>
                </div>
                <div class="right_box right_3 right_fruit">
                    <img src="@/assets/images/QcDownload/box_fruit.png" alt="">
                    <p>千橙收银生鲜版</p>
                    <div class="box_btn">
                        <div class="btn1" @click="addTimeStamps(QcCashierFruitUrl)">
                            <div class="btn_text">安卓客户端</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content_left content_left2">
                <div class="left_title">千橙社群营销系统</div>
                <div class="left_text">社群裂变会员营销</div>
            </div>
            <div class="content_right">
                <div class="right_box">
                    <img src="@/assets/images/QcDownload/box3.png" alt="">
                    <p>千橙微商城</p>
                    <div class="box_btn">
                        <div class="btn1" @click="addTimeStamps(QcShoppingMallUrl)">
                            <div class="btn_text"  >安卓客户端</div>
                        </div>
                        <div class="btn2" @click="goApple('https://itunes.apple.com/cn/app/id6472264795')">
                            <div class="btn_text" >苹果客户端</div>
                        </div>
                    </div>
                </div>
                <div class="right_box">
                    <img src="@/assets/images/QcDownload/box4.png" alt="">
                    <p>汇团团</p>
                    <div class="box_btn">
                        <div class="btn3">
                            <div class="btn_text" @click="selectMark(1)">扫码识别</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content_left  content_left3">
                <div class="left_title">千橙电商系统</div>
                <div class="left_text">线上渠道增量提效增收</div>
            </div>
            <div class="content_right">
                <div class="right_box">
                    <img src="@/assets/images/QcDownload/box5.png" alt="">
                    <p>千橙电商</p>
                    <div class="box_btn">
                        <div class="btn1" @click="addTimeStamps(QcCommerceUrl)">
                            <div class="btn_text"  >安卓客户端</div>
                        </div>
                        <div class="btn2" @click="goApple('https://apps.apple.com/tt/app/%E6%A9%99%E6%84%8F%E6%8E%8C%E6%9F%9C/id1563349231')">
                            <div class="btn_text" >苹果客户端</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content_left content_left4">
                <div class="left_title">千橙分销系统</div>
                <div class="left_text">商机+业务员分销管理</div>
            </div>
            <div class="content_right">
                <div class="right_box">
                    <img src="@/assets/images/QcDownload/box6.png" alt="">
                    <p>千橙分销</p>
                    <div class="box_btn" @click="selectMark(2)">
                        <div class="btn3">
                            <div class="btn_text">扫码识别</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content_left content_left5">
                <div class="left_title">千橙智能服务平台</div>
                <div class="left_text">提升运营服务效率</div>
            </div>
            <div class="content_right ">
                <div class="right_box">
                    <img src="@/assets/images/QcDownload/box7.png" alt="">
                    <p>千橙数字人</p>
                    <div class="box_btn">
                        <div class="btn4">
                            <div class="btn_text">内测申请</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="bottom_text">
        更多产品 持续更新 欢迎关注～
      </div>
      <div class="mark" v-if="isMark" @click="isMark = false">
        <div class="mark_box">
            <img class="seek_close" @click="isMark =false" src="@/assets/images/seek_close.png" alt="">
            <div class="mark_title">{{selectItem == '1'? '汇团团' :selectItem == '2'? '千橙分销':'' }}</div>
            <div class="mark_code">
                <img class="mark_code1" v-if="selectItem == '1'" src="@/assets/images/login/code4.png" alt="">
                <img class="mark_code2" v-if="selectItem == '2'" src="@/assets/images/login/code5.png" alt="">
            </div>
        </div>
      </div>
      <!-- <Contact /> -->
      <!-- <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      /> -->
    </div>
  </template>

  <script>
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";

  export default {
    metaInfo: metaInfo.QcDownload,
    components: {
      TryModal,
      Contact,
    },
    data() {
      return {
        isMark:false,
        selectItem:'',
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
        QcShopkeeperUrl: '',//千橙掌柜安卓下载地址
        QcCashierUrl: '',//千橙收银安卓下载地址
        QcCashierFruitUrl: '', // 千橙收银安卓生鲜版下载地址
        QcShoppingMallUrl: '',//千橙微商城安卓下载地址
        QcCommerceUrl: '',//千橙电商安卓下载地址
      };
    },
    mounted() {
        this.getQcShopkeeperUrl()
        this.getQcCashierUrl()
        this.getQcShoppingMallUrl()
        this.getQcCashierFruitUrl()
        this.getQcCommerceUrlUrl()
    },
    methods: {
        selectMark(item){
            this.selectItem = item
            this.isMark = true
        },
        getQcCommerceUrlUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("post", 'https://gateway.qcos.cn/prod/saasapi/member/storeAppVersion/getStoreAppVersion');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            var data = JSON.stringify({ 'appSource': 1,'platForm': 1 });
            ajax.send(data);
            // 注册事件
            ajax.onreadystatechange = function () {
            if (ajax.readyState == 4 && ajax.status == 200) {
                //console.log(ajax.responseText);
                var str = ajax.responseText;
                //将json字符串转换为json对象
                var obj = eval("(" + str + ")");
                _this.QcCommerceUrl= obj.data.versionUrl;
                console.log(_this.QcCommerceUrl,'QcCommerceUrl')
            }
            };
        },
        getQcShopkeeperUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.qcos.cn/prod/htdtapp/notAuth/bossappVersion/getBossAppVersion?appSource=1002&callback=callbackfunction&channelType=1');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
            if (ajax.readyState == 4 && ajax.status == 200) {
                //console.log(ajax.responseText);
                var str = ajax.responseText;
                //将json字符串转换为json对象
                var obj = eval("(" + str + ")");
                _this.QcShopkeeperUrl= obj.data.appUrl;
                console.log(_this.QcShopkeeperUrl,'QcShopkeeperUrl')
            }
            };
        },
        getQcCashierFruitUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.htd.cn/prod/htdtcashier/appVersion/getAppVersion?industryNo=1004');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
                if (ajax.readyState == 4 && ajax.status == 200) {
                    //console.log(ajax.responseText);
                    var str = ajax.responseText;
                    //将json字符串转换为json对象
                    var obj = eval("(" + str + ")");
                    var list = obj.data.rows;
                    var item = list[0];
                    _this.QcCashierFruitUrl = item.appUrl;
                }
            };
        },
        getQcCashierUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.htd.cn/prod/htdtcashier/appVersion/getAppVersion?appSource=1003&callback=callbackfunction&channelType=1');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
                if (ajax.readyState == 4 && ajax.status == 200) {
                    //console.log(ajax.responseText);
                    var str = ajax.responseText;
                    //将json字符串转换为json对象
                    var obj = eval("(" + str + ")");
                    var list = obj.data.rows;
                    var item = list[0];
                    _this.QcCashierUrl = item.appUrl;
                }
            };
        },
        getQcShoppingMallUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.qcos.cn/prod/htdtapp/notAuth/bossappVersion/getBossAppVersion?appSource=1005&callback=callbackfunction&channelType=1');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
                if (ajax.readyState == 4 && ajax.status == 200) {
                    //console.log(ajax.responseText);
                    var str = ajax.responseText;
                    //将json字符串转换为json对象
                    var obj = eval("(" + str + ")");
                    _this.QcShoppingMallUrl = obj.data.appUrl;
                }
            };
        },
        goApple(url) {
            console.log(url,'1234')
            // window.location.href = url;
            window.open(url);
        },
        addTimeStamps(url) {
            // console.log(this.QcShopkeeperUrl,'QcShopkeeperUrl')
            // let url  = this.QcShopkeeperUrl;
            var timestamp = Date.parse(new Date());
            if (url.indexOf("?") != -1) { // 包含？
                url = url + "&timestamp=" + timestamp;
            } else {
                url = url + "?timestamp=" + timestamp;
            }
            // window.open(url, '_blank');
            location.href = url;
        },
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>

  <style lang="less" scoped>
  .mark{
    position:fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 1000;
    .mark_box{
        width: 400px;
        height: 450px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background: #FFFFFF;
        .seek_close{
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
    }
        .mark_title{
            height: 50px;
            font-size: 22px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 50px;
            margin-top: 10px;
        }
        .mark_code{
            width:400px;
            height:400px;
            display: flex;
            justify-content: center;
            align-items: center;
            .mark_code1{
                width:300px;
                height:300px;
            }
            .mark_code2{
                width:255px;
                height:360px;
            }
        }
    }
  }
    .bottom_text{
        height:147px;
        line-height:147px;
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        background: #F5F5F5;
    }
    .download{
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: #F5F5F5;
        align-items: center;
        .content{
            width: 1200px;
            height:500px;
            background: #FFFFFF;
            display: flex;
            flex-direction: row;
            margin-top: 60px;
            .content_left2{
                background: url("~@/assets/images/QcDownload/content2.png") no-repeat center;
            }
            .content_left3{
                background: url("~@/assets/images/QcDownload/content3.png") no-repeat center;
            }
            .content_left4{
                background: url("~@/assets/images/QcDownload/content4.png") no-repeat center;
            }
            .content_left5{
                background: url("~@/assets/images/QcDownload/content5.png") no-repeat center;
            }
            .content_left1{
                background: url("~@/assets/images/QcDownload/content1.png") no-repeat center;
            }
            .content_left{
                width: 355px;
                height: 500px;
                background-size: 355px 500px;
                .left_title{
                    width: 288px;
                    height: 50px;
                    font-size: 36px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 50px;
                    margin-top:47px;
                    margin-left:25px;
                }
                .left_text{
                    width: 160px;
                    height: 28px;
                    font-size: 20px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-top:15px;
                    margin-left:25px;
                }
            }
            .content_right{
                width: 845px;
                min-height: 500px;
                display: flex;
                flex-direction: row;
                align-items: center;
                align-content: space-evenly;
                .right_box{
                    width: 382px;
                    height: 420px;
                    background: #FFFFFF;
                    border: 1px solid #EAEAEA;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-left: 27px;
                    img{
                        width: 142px;
                        height: 142px;
                        margin-top: 68px;
                    }
                    p{
                        font-size: 28px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                        line-height: 40px;
                        margin-top: 28px;
                        margin-bottom:0px;
                    }
                    .box_btn{
                        width: 100%;
                        height:46px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-evenly;
                        margin-top: 48px;
                        .btn_text{
                            height: 25px;
                            font-size: 18px;
                            font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
                            font-weight: normal;
                            color: #FFFFFF;
                            line-height: 46px;
                            margin-left: 12px;
                        }
                        .btn1{
                            width: 156px;
                            height: 46px;
                            background: #67B444;
                            border-radius: 23px;
                            background-image: url("~@/assets/images/QcDownload/android.png");
                            background-repeat: no-repeat;
                            background-position:15px 11px;
                            background-size: 20px 20px;
                            cursor: pointer;
                        }
                        .btn2{
                            width: 156px;
                            height: 46px;
                            background: #1584F7;
                            border-radius: 23px;
                            background-image: url("~@/assets/images/QcDownload/apple.png");
                            background-repeat: no-repeat;
                            background-position:15px 11px;
                            background-size: 20px 20px;
                            cursor: pointer;
                        }
                        .btn3{
                            width: 156px;
                            height: 46px;
                            background: #40B4CB;
                            border-radius: 23px;
                            background-image: url("~@/assets/images/QcDownload/scan.png");
                            background-repeat: no-repeat;
                            background-position:15px 11px;
                            background-size: 20px 20px;
                            cursor: pointer;
                        }
                        .btn4{
                            width: 156px;
                            height: 46px;
                            background: #40B4CB;
                            border-radius: 23px;
                            background-image: url("~@/assets/images/QcDownload/test.png");
                            background-repeat: no-repeat;
                            background-position:15px 11px;
                            background-size: 20px 20px;
                            cursor: pointer;
                        }
                    }
                }
                .right_top {
                    margin-top: 30px;
                }
                .right_3 {
                    width: 280px;
                    height: 430px;
                    .box_btn {
                        margin-top: 20px;
                        height: 106px;
                        flex-direction: column;
                        justify-content: space-between;
                    }
                }
                .right_fruit {
                    margin-right: 27px;
                }
            }
        }
        .content_store {
            .content_left {
                background-size: 355px 500px;
            }
        }
    }

  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }

  .custom{
          height:662px;
          background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          align-items:center;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          text-align: left;
          background: rgba(255,255,255,.5);
          margin-top: 42px;
          height:439px;
          .custom_item{
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              padding:0 150px;
              .cutom_box{
                  width:260px;
                  height:89px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  margin-top:140px;
                  .box_item{
                      display: flex;
                      flex-direction: column;
                      .box_title{
                          width: 71px;
                          height: 45px;
                          font-size: 32px;
                          font-family: PingFangSC, PingFang SC;
                          font-weight: 600;
                          color: #333333;
                          line-height: 45px;
                      }
                      .box_line{
                          width: 43px;
                          height: 5px;
                          background: #3986FF;
                      }
                      .box_span{
                          width: 96px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #595961;
  line-height: 22px;
                      }
                  }
              }
              .custom_item_text{
                  margin-left: 50px;
                  .title{
                      height: 40px;
                      font-size: 22px;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 600;
                      color: #333333;
                      line-height: 40px;
                  }
                  .text{
                      height: 20px;
                      font-size: 16px;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 500;
                      color: #333333;
                      line-height: 20px;
                      margin-top:30px;
                  }
              }
              img{
                  width: 438px;
                  height: 302px;
              }
          }
      }
  }
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }

    .banner {
      background: url("~@/assets/images/QcDownload/banner.png") no-repeat center;
      background-size: 1920px 420px;
      min-width: 1200px;
      min-height:420px;
      display: flex;
    // align-items: center;
    justify-content: center;
      .content{
        width: 1920px;
        display: flex;
        flex-direction: column;
        .banner_title{
            width: 312px;
            height: 72px;
            font-size: 52px;
            font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
            font-weight: normal;
            color: #FFFFFF;
            line-height: 72px;
            margin-top: 112px;
            margin-left: 360px;
        }
        .banner_text{
            width: 256px;
            height: 45px;
            font-size: 32px;
            font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
            font-weight: normal;
            color: #FFFFFF;
            line-height: 45px;
            margin-top: 26px;
            margin-left: 360px;
        }
      }
  }
  </style>
